import { Box, useTheme } from "@mui/material";

interface NotificationCountChipProps {
  count: number;
}

/**
 * The Recent count beside a "Notifications" menu entry. The server caps the
 * count at 100, so anything above 99 reads "99+".
 */
const NotificationCountChip = ({ count }: NotificationCountChipProps) => {
  const theme = useTheme();

  return (
    <Box
      component="span"
      aria-label={`${count > 99 ? "More than 99" : count} new`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 20,
        height: 20,
        px: 0.75,
        borderRadius: "10px",
        fontSize: "0.6875rem",
        fontWeight: 700,
        fontVariantNumeric: "tabular-nums",
        // The darker green keeps small digits legible on the light wash
        color: theme.palette.mode === "dark" ? "#22c55e" : "#16a34a",
        backgroundColor: "rgba(34, 197, 94, 0.12)",
      }}
    >
      {count > 99 && "99+"}
      {count <= 99 && count}
    </Box>
  );
};

export default NotificationCountChip;
